<div class="annex-summary-container">
  <div class="content-card">
    <h2 class="content-card__header">{{ 'Annex.BasicData' | translate }}</h2>

    <table>
      <tbody>
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'FullName' | translate }}</td>
          <td class="key-value-row__value">{{ agreement.FullName }}</td>
        </tr>
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'EmploymentType' | translate }}</td>
          <td class="key-value-row__value">{{ agreement.EmploymentType }}</td>
        </tr>
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'AgreementConclusionDate' | translate }}</td>
          <td class="key-value-row__value">{{ agreement.ConclusionDate | date: 'yyyy-MM-dd' }}</td>
        </tr>
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'EmploymentDateFrom' | translate }}</td>
          <td class="key-value-row__value">{{ agreement.EmploymentDateFrom | date: 'yyyy-MM-dd' }}</td>
        </tr>
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'EmploymentDateTo' | translate }}</td>
          <td class="key-value-row__value">{{ agreement.EmploymentDateTo | date: 'yyyy-MM-dd' }}</td>
        </tr>
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'Annex.ConclusionDate' | translate }}</td>
          <td class="key-value-row__value">{{ annexData.AnnexConclusionDate | date: 'yyyy-MM-dd' }}</td>
        </tr>
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'Annex.DateFrom' | translate }}</td>
          <td class="key-value-row__value">{{ annexData.AnnexStartDate | date: 'yyyy-MM-dd' }}</td>
        </tr>
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'Annex.DateTo' | translate }}</td>
          @if (annexData.AnnexEndDate) {
            <td class="key-value-row__value">{{ annexData.AnnexEndDate | date: 'yyyy-MM-dd' }}</td>
          } @else {
            <td class="key-value-row__value">{{ 'Annex.IsIndefinite' | translate }}</td>
          }
        </tr>
      </tbody>
    </table>
  </div>

  @if (hasAnyChanges) {
    <div class="content-card changes-card">
      <h2 class="content-card__header">{{ 'Annex.ChangedData' | translate }}</h2>
      <table class="changes-table">
        <thead>
          <tr>
            <th class="changes-table__field"></th>
            <th class="changes-table__current">{{ currentColumnLabel | translate }}</th>
            <th class="changes-table__new">{{ 'Annex.New' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @if (hasOrganizationalUnitChange) {
            <tr class="change-row">
              <td class="change-row__field">
                <strong>{{ 'OrganizationalUnit' | translate }}</strong>
              </td>
              <td class="change-row__current">
                {{ dataForAnnex.OrganizationalUnitName || '-' }}
              </td>
              <td class="change-row__new">
                {{ annexData.OrganizationalUnitName }}
              </td>
            </tr>
          }
          @if (hasJobTitleChange) {
            <tr class="change-row">
              <td class="change-row__field">
                <strong>{{ 'JobTitle' | translate }}</strong>
              </td>
              <td class="change-row__current">
                {{ dataForAnnex.JobTitleName || '-' }}
              </td>
              <td class="change-row__new">
                {{ annexData.JobTitleName }}
              </td>
            </tr>
          }
          @if (hasSupervisorSectionChange) {
            <tr class="change-row">
              <td class="change-row__field">
                <strong>{{ 'Annex.Supervisor' | translate }}</strong>
              </td>
              <td class="change-row__current">
                {{ dataForAnnex.PotentialSupervisorName || '-' }}
              </td>
              <td class="change-row__new">
                {{ newSupervisorName }}
              </td>
            </tr>
          }
          @if (hasWorkingTimeSectionChange) {
            <tr class="change-row">
              <td class="change-row__field">
                <strong>{{ 'WorkingTimeGroup' | translate }}</strong>
              </td>
              <td class="change-row__current">
                {{ dataForAnnex.WorkingTimeGroupName || '-' }}
              </td>
              <td class="change-row__new">
                {{ annexData.WorkingTimeGroupName }}
              </td>
            </tr>
          }
          @if (hasTemporaryWorkplaceSectionChange) {
            <tr class="change-row">
              <td class="change-row__field">
                <strong>{{ 'Workplace' | translate }}</strong>
              </td>
              <td class="change-row__current">
                {{ dataForAnnex.TemporaryWorkplaceName || '-' }}
              </td>
              <td class="change-row__new">
                {{ annexData.TemporaryWorkplaceName }}
              </td>
            </tr>
          }

          @if (hasWagesSectionChange) {
            @for (wage of currentWages; track wage; let i = $index) {
              <tr class="change-row wage-row">
                <td class="change-row__field">
                  <strong>{{ 'Wage' | translate }} #{{ i + 1 }}</strong>
                </td>
                <td class="change-row__current wage-details">
                  <div class="wage-type">{{ wage.WageTypeName }}</div>
                  @if (wage.Value) {
                    <div class="wage-value">{{ wage.Value | wageValue }} {{ wage.CurrencyName }}</div>
                  }
                  @if (wage.CalculationDescription) {
                    <div class="wage-description">
                      {{ wage.CalculationDescription }}
                    </div>
                  }
                </td>
                @if (newWages[i]) {
                  <td class="change-row__new wage-details">
                    <div class="wage-type">{{ newWages[i].WageTypeName || '-' }}</div>
                    @if (newWages[i].Value) {
                      <div class="wage-value">{{ newWages[i].Value | wageValue }} {{ newWages[i].CurrencyName }}</div>
                    }
                    @if (newWages[i].CalculationDescription) {
                      <div class="wage-description">
                        {{ newWages[i].CalculationDescription }}
                      </div>
                    }
                  </td>
                }
                @if (!newWages[i]) {
                  <td class="change-row__new">
                    <span class="removed-indicator"></span>
                  </td>
                }
              </tr>
            }
            @for (wage of newWages.slice(currentWages.length); track wage; let i = $index) {
              <tr class="change-row wage-row">
                <td class="change-row__field">{{ 'Wage' | translate }} #{{ currentWages.length + i + 1 }}</td>
                <td class="change-row__current">
                  <span class="added-indicator"></span>
                </td>
                <td class="change-row__new wage-details">
                  <div class="wage-type">{{ wage.WageTypeName || '-' }}</div>
                  @if (wage.Value) {
                    <div class="wage-value">{{ wage.Value | number: '1.2-2' }} {{ wage.CurrencyName }}</div>
                  }
                  @if (wage.CalculationDescription) {
                    <div class="wage-description">
                      {{ wage.CalculationDescription }}
                    </div>
                  }
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  }
</div>
